import { HTTP } from "../../service/helper";

// initial state
const state = () => ({
   egiftCardLists: "",
});

// getters
const getters = {
   geteGiftCardLists(state) {
      return state.egiftCardLists;
   },
};

// actions
const actions = {

   geteGiftCardLists({ commit },category) {

      return new Promise((resolve, reject) => {

         HTTP.get("/v1/egift-cards-list/"+category+"")
            .then((response) => {
               commit("setGiftCardLists", response.data.data);
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },

   getPaymentTypeLists(_,brandName){

      return new Promise((resolve, reject) => {
         HTTP.get("/v1/paymenttype-list/3?brand=" + brandName)
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },
   
   egiftCardSearch(_,name){

      return new Promise((resolve, reject) => {
         HTTP.get("/v1/egift-cards-list-search/"+name+"")
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },

   egiftCardDetail(_,name){

      return new Promise((resolve, reject) => {
         HTTP.get("/v1/egift-cards-detail/"+name+"")
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },

   exchangeRate(){

      return new Promise((resolve, reject) => {
         HTTP.get("/v1/exchange-rate-list")
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
   },

   topupProcess(_,data){

      return new Promise((resolve, reject) => {

         HTTP.post("/v1/egift-card-transactions",data)
            .then((response) => {
               resolve(response);
            })
            .catch((error) => {
               reject(error.response.data);
            });
      });
      
   },
};

// mutations
const mutations = {
   setGiftCardLists(state, payload) {
      state.egiftCardLists = payload;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};
